import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'reactstrap';

import Sort from 'components/Sort';
import ProductCard from 'components/ProductCard';
import useResultFilter from 'hooks/use-result-filter';
import ProductCardSkeleton from 'components/ProductCard/skeleton';
import Pagination from 'components/Pagination';

export default function List() {
  const { data, isLoading } = useResultFilter();

  return (
    <React.Fragment>
      <section className="section">
        <Container>
          <Row className="align-items-center">
            <Col lg={3} md={7}>
              <div className="section-title">
                <h6 className="mb-0 mb-md-4">
                  Yaklaşık {data?.totalCount ?? 0} sonuç bulundu
                </h6>
              </div>
            </Col>

            <Sort />
          </Row>

          <Row>
            {isLoading ? (
              <ProductCardSkeleton />
            ) : data?.data?.length <= 0 ? (
              <div className="alert bg-warning-subtle border border-warning-subtle text-warning-emphasis text-center py-3">
                <h4 className="alert-heading">Sonuç bulunamadı.</h4>
                <p>Aramanıza uygun sonuç bulunamadı. Filtreleri temizleyerek tüm sayılara ulaşmak için aşağıdaki butona tıklayınız.</p>
                <hr />
                <Link
                  to="/publications" 
                  className="btn btn-secondary">Tüm Sayılar</Link>
              </div>
            ) : (
              data?.data.map((product, key) => (
                <ProductCard key={key} {...product} />
              ))
            )}
            <Pagination data={data} />
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
}
